import { State as LandlordTableState } from "../reducers/landlord-table";
import { createFeatureSelector, createSelector } from "@ngrx/store";
export const selectLandlordTableState = createFeatureSelector<LandlordTableState>('landlordTable');


export const getAllLandlordsWithDataKey = createSelector(
  [selectLandlordTableState],
  (landlordTableState: LandlordTableState) => {
    if (landlordTableState.landlordTable != undefined) {
      var count = 1;
      for (let landlord of landlordTableState.landlordTable.Rows) {
        landlord.DataKey = String(count++);
      }
    }
    return landlordTableState.landlordTable;
  }
);
